import { Link, useNavigate } from "react-router-dom";
import '../../CSS/layout/Header.css';
import logo from '../../resource/water_logo(white).png';
import logo2 from '../../resource/hamham.png';
import { useEffect, useState } from "react";
import { BASE_URL } from '../../Config';

const Header = () => {
    const navigate = useNavigate();
    const [isLoggedIn, setIsLoggedIn] = useState(false);
    const [userState, setUserState] = useState(null);
    const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

    useEffect(() => {
        const handleLogin = () => {
            const storedUser = localStorage.getItem("user");
            if (storedUser) {
                const parsed = JSON.parse(storedUser);
                setIsLoggedIn(true);
                setUserState(parsed.state); // ← 상태 저장 (R, Y 등)
            } else {
                setIsLoggedIn(false);
                setUserState(null);
            }
        };

        handleLogin(); // 첫 진입 시 실행
        window.addEventListener("login", handleLogin); // 커스텀 이벤트로 로그인 반영

        return () => window.removeEventListener("login", handleLogin);
    }, []);

    const handleLogout = () => {
        localStorage.removeItem("user");
        setIsLoggedIn(false);
        setUserState(null);
        navigate("/login");
    };

    const excelDownload = () => {
        window.open(`${BASE_URL}/download/users`, "_blank");
    };


    return (
        <header className="header">
            <div className="header-inner">
                <Link to="/" className="logo">
                    <img src={logo} alt="Teamtoys Logo" />
                </Link>

                {/* 데스크탑 메뉴 */}
                <nav className="nav-menu">
                    <Link to="/about">펜션안내</Link>
                    <Link to="/rooms">객실안내</Link>
                    <Link to="/reservation">예약안내</Link>
                    <Link to="/services">서비스이용</Link>
                    <Link to="/gallery">갤러리</Link>
                </nav>

                {/* 햄버거 메뉴 (모바일용) */}
                <div className="hamburger" onClick={() => setIsMobileMenuOpen(true)}>
                    <img src={logo2} alt="Teamtoys Logo"/>
                </div>

                {/* 모바일 메뉴 (사이드바) */}
                {isMobileMenuOpen && (
                    <>
                        <div className="backdrop" onClick={() => setIsMobileMenuOpen(false)}></div>
                        <div className="mobile-menu">
                            <Link to="/">홈</Link>
                            <Link to="/about">펜션안내</Link>
                            <Link to="/rooms">객실안내</Link>
                            <Link to="/reservation">예약안내</Link>
                            <Link to="/services">서비스이용</Link>
                            <Link to="/gallery">갤러리</Link>
                        </div>
                    </>
                )}
            </div>
        </header>
    );
};

export default Header;
